import { Group, Stack, Text } from "@mantine/core";
import { IconUpload, IconX } from "@tabler/icons-react";
import { Dropzone, DropzoneProps } from "@mantine/dropzone";
import { importTasksFromCsv } from "../../entities/articles/utils/import-articles-from-csv";
import { useEffect, useState } from "react";

type Props = {
  props?: Partial<DropzoneProps>;
  onUpdate?: (articles: Array<{ url: string; date?: Date, skipCutLongSentences?: boolean }>) => void;
};

export const CsvFileInput = ({ props, onUpdate }: Props = {}) => {
  const [articles, setArticles] = useState<Array<{ url: string; date?: Date, skipCutLongSentences?: boolean }>>(
    []
  );

  const handleReturnTasks = async (files: File[]) => {
    const articles = await importTasksFromCsv(files[0]);

    console.log("articles", articles);
    setArticles(articles);
  };

  useEffect(() => {
    onUpdate?.(articles);
  }, [articles]);

  return (
    <Dropzone
      onDrop={(files) => handleReturnTasks(files)}
      onReject={() => setArticles([])}
      maxSize={5 * 1024 ** 2}
      accept={["text/csv"]}
      multiple={false}
      {...props}
    >
      <Group
        justify="center"
        wrap="nowrap"
        gap="sm"
        style={{ pointerEvents: "none" }}
      >
        <Dropzone.Accept>
          <IconUpload
            size={52}
            color="var(--mantine-color-blue-6)"
            stroke={1.5}
          />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX size={48} color="var(--mantine-color-red-6)" stroke={1.5} />
        </Dropzone.Reject>

        <Stack gap={0} align="center" justify="center">
          <Text size="sm" fw={500} ta="center">
            Drag csv here or click to select files
          </Text>
          <Text size="xs" c="dimmed" inline mt={7} ta="center">
            Csv file should not exceed 5mb
          </Text>
        </Stack>
      </Group>
    </Dropzone>
  );
};
